import { createFileRoute } from "@tanstack/react-router";

// The chat panel is owned by the layout route (`$agentId.tsx`) so it survives
// `/chat/$agentId` → `/chat/$agentId/c/$threadId` without remounting and losing
// the just-sent message. This leaf only matches the URL; rendering here too
// would mount a second panel.
export const Route = createFileRoute("/$owner/chat/$agentId/")({
	component: () => null,
});
